import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useConsent } from "./ConsentContext";
import { GA_ID, clearGaCookies } from "./store";

// Încarcă gtag.js o singură dată, numai după consimțământ.
function loadGtag() {
  if (document.getElementById("gtag-selik")) {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  const s = document.createElement("script");
  s.id = "gtag-selik";
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
}

// Trimite page view pentru pagina curentă, o singură dată per ruta.
function sendPageView(path) {
  if (typeof window.gtag !== "function") return;
  window.gtag("config", GA_ID, {
    send_page_view: false,
    page_path: path,
    page_location: window.location.href,
  });
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
  });
}

const ConsentAnalytics = () => {
  const { consent } = useConsent();
  const { pathname } = useLocation();
  const lastSent = useRef(null);

  // Reacție la schimbarea rutei
  useEffect(() => {
    if (!consent || consent.analytics !== true) return;
    if (typeof window.gtag !== "function") {
      loadGtag();
    }
    if (lastSent.current === pathname) return;
    sendPageView(pathname);
    lastSent.current = pathname;
  }, [consent, pathname]);

  // La retragerea consimțământului: fără tracking, fără cookie-uri GA
  useEffect(() => {
    if (!consent || consent.analytics === true) return;
    if (typeof window.gtag === "function") {
      window.gtag("consent", "update", { analytics_storage: "denied" });
    }
    clearGaCookies();
  }, [consent]);

  return null;
};

export default ConsentAnalytics;
